<template>
  <div>
    <div class="row" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{
            bold: control.labelBold,
            italic: control.labelItalic,
            underline: control.labelUnderline
          }"
        >
          {{ control.label }}
        </label>
      </div>
      <div class="col-md-8">
        <input
          v-if="!readonly"
          type="text"
          class="form-control"
          :readonly="this.control.readonly"
          :name="control.fieldName"
          :maxlength="control.maxLength"
          v-model="control.value"
        />
        <span v-else>{{ control.value }}</span>
      </div>
    </div>
    <div v-else class="form-group">
      <label
        :class="{
          bold: control.labelBold,
          italic: control.labelItalic,
          underline: control.labelUnderline
        }"
      >
        {{ control.label }}
      </label>

      <input
        v-if="!readonly"
        type="text"
        class="form-control"
        :readonly="this.control.readonly"
        :name="control.fieldName"
        :maxlength="control.maxLength"
        v-model="control.value"
      />
      <span v-else>{{ control.value }}</span>
    </div>
  </div>
</template>

<script>
import { Hooks } from '../../../gui/components/hook_lists';

export default {
  name: 'raTextControl',
  props: ['control', 'labelPosition', 'readonly'],
  mounted() {
    if (_.toInteger(this.control.maxLength) == 0) {
      this.control.maxLength = null;
    }
    if (!_.isEmpty(this.control.defaultValue)) {
      this.control.value = this.control.defaultValue;
    }

    // after hook
    Hooks.Control.afterInit.run(this.control, $(this.$el).find('input'));
  }
};
</script>

<style scoped></style>
